var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9844 7C23.5156 7 23.9844 7.20312 24.3906 7.60938C24.7969 8.01562 25 8.48438 25 9.01562V22.9844C25 23.5156 24.7969 23.9844 24.3906 24.3906C23.9844 24.7969 23.5156 25 22.9844 25H9.01562C8.48438 25 8.01562 24.7969 7.60938 24.3906C7.20312 23.9844 7 23.5156 7 22.9844V9.01562C7 8.48438 7.20312 8.01562 7.60938 7.60938C8.01562 7.20312 8.48438 7 9.01562 7H22.9844ZM22.9844 9.01562H9.01562V22.9844H22.9844V9.01562Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckbox);
export default __webpack_public_path__ + "static/media/ic_checkbox.8e3a491a83184a4ecfaa94a135c6d972.svg";
export { ForwardRef as ReactComponent };